import { useState } from 'react'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { usePostIntegrator, type IntegratorDto } from '@dhl/mdp-api'
import { Box, Card, Grid, H5 } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import { useNotificationMessage } from '~/common'
import { CancelDialog, createValidationSchema, type FormValues, IntegratorForm } from '~/modules/integrators/components'
import { BackButton } from '~/temp-ds-component/BackButton'

export const IntegratorAddPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { showSuccess, showError } = useNotificationMessage()
  const [cancelDialogOpen, setCancelDialogOpen] = useState<boolean>(false)
  const { mutate: postIntegrator } = usePostIntegrator()

  const initialValues: FormValues = {
    name: '',
    description: '',
    limitedTrackTrace: false,
  }

  const validationSchema = createValidationSchema(t)

  const onSubmit = (integrator: IntegratorDto) => {
    postIntegrator(
      {
        data: integrator,
      },
      {
        onSuccess: () => {
          showSuccess(t('admin.integratorsPage.createdIntegrator'))
          navigate(links.integratorsLink())
        },
        onError: (response) => {
          showError(response?.message ?? t('admin.integratorsPage.errorMessage'))
        },
      }
    )
  }

  const onBack = (dirty: boolean) => {
    dirty ? setCancelDialogOpen(true) : navigate(links.integratorsLink())
  }

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validateOnMount validationSchema={validationSchema}>
        {({ dirty }) => (
          <>
            <Grid>
              <Box marginBottom={2}>
                <BackButton onClick={() => onBack(dirty)}>{t('admin.integratorsPage.backButtonTitle')}</BackButton>
              </Box>
            </Grid>
            <Card>
              <Card.Header title={t('admin.integratorsPage.titleText')} />
              <Card.Content>
                <H5>{t('admin.integratorsPage.accountInformation')}</H5>
                <IntegratorForm onCancel={() => onBack(dirty)} />
              </Card.Content>
            </Card>
          </>
        )}
      </Formik>
      <CancelDialog open={cancelDialogOpen} onCancel={() => setCancelDialogOpen(false)} />
    </>
  )
}
